export const localValidate = (formState) => {
  let errors = {};

  if (formState.hasTimeStandards !== true && formState.hasTimeStandards !== false) {
    errors.hasTimeStandards = 'A selection is required';
  }

  else if (formState.hasTimeStandards === true) {

    if (formState.hasNoSlowerThanTimeStandards !== true && formState.hasNoSlowerThanTimeStandards !== false) {
      errors.hasNoSlowerThanTimeStandards = 'A selection is required';
    }

    if (formState.hasNoFasterThanTimeStandards !== true && formState.hasNoFasterThanTimeStandards !== false) {
      errors.hasNoFasterThanTimeStandards = 'A selection is required';
    }

    if (formState.bonusEvents === true && formState.hasBonusTimeStandards !== true && formState.hasBonusTimeStandards !== false) {
      errors.hasBonusTimeStandards = 'A selection is required';
    }

    if (formState.bonusEvents === true && formState.hasBonusTimeStandards !== true && formState.hasNoSlowerThanTimeStandards !== true && formState.hasNoFasterThanTimeStandards !== true) {
      errors.error = "'Meet uses Time Standards' is set to 'Yes'. At least one of the 'No Slower Than', 'No Faster Than', or 'Bonus' fields must be set to 'Yes'.";
    }

    if (formState.bonusEvents === false && formState.hasNoSlowerThanTimeStandards !== true && formState.hasNoFasterThanTimeStandards !== true) {
      errors.error = "'Meet uses Time Standards' is set to 'Yes'. At least one of the 'No Slower Than' or 'No Faster Than' fields must be set to 'Yes'.";
    }

    if (formState.hasNoFasterThanTimeStandards === true) {
      if (formState.hasAthleteExceedsTimeStandardsRule !== true && formState.hasAthleteExceedsTimeStandardsRule !== false) {
        errors.hasAthleteExceedsTimeStandardsRule = 'A selection is required';
      }

      if (formState.relayEvents === true && formState.hasAthleteExceedsTimeStandardsRelayRule !== true && formState.hasAthleteExceedsTimeStandardsRelayRule !== false) {
        errors.hasAthleteExceedsTimeStandardsRelayRule = 'A selection is required';
      }
    }
  }

  return errors;
};

const OmeTimeStandardsValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};
export default OmeTimeStandardsValidation;